import { MessageBarType } from '@fluentui/react';
import { useToast } from '@h2oai/ui-kit';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';

export const ProviderAppQueryClient = (props: { children: React.ReactNode }) => {
  const toast = useToast();
  const queryClient = React.useState(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
        },
      },
      queryCache: new QueryCache({
        onError: (error, query) => {
          if (query.meta?.toastError) {
            const message =
              typeof query.meta.toastError === `function` ? query.meta.toastError(error) : query.meta.toastError;
            if (message) {
              toast.addToast({
                message,
                messageBarType: MessageBarType.error,
              });
            }
          }
        },
      }),
      mutationCache: new MutationCache({
        onError: (error, _variables, _context, mutation) => {
          if (mutation.meta?.toastError) {
            const message =
              typeof mutation.meta.toastError === `function`
                ? mutation.meta.toastError(error)
                : mutation.meta.toastError;
            if (message) {
              toast.addToast({
                message,
                messageBarType: MessageBarType.error,
              });
            }
          }
        },
      }),
    });
  })[0];
  return (
    <QueryClientProvider client={queryClient}>
      {props.children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
